import { format, isValid, parseISO, subDays } from 'date-fns';

export const formatDate = (timestamp: string): string => {
    if (!timestamp) return '';

    const date = new Date(timestamp);

    if (isNaN(date.getTime())) return '';

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

export const safeStringToDate = (dateString: string | null | undefined): Date => {
  if (!dateString) return new Date();

  const isoDate = parseISO(dateString);
  if (isValid(isoDate)) return isoDate;

  const normalDate = new Date(dateString);
  if (isValid(normalDate)) return normalDate;

  return new Date();
};

export const formatDateForAPI = (date: Date | null | undefined): string => {
  if (!date || !isValid(date)) {
    return format(new Date(), 'yyyy-MM-dd');
  }
  return format(date, 'yyyy-MM-dd');
};

export const getDefaultDate = (): Date => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

/** Período padrão da tela de pedidos: últimos 7 dias (inclusive). */
export const getDefaultOrdersDateRange = (): { from: Date; to: Date } => {
  const to = getDefaultDate();
  const from = subDays(to, 6);
  from.setHours(0, 0, 0, 0);
  return { from, to };
};

export const safeDateToISOString = (date: Date | null | undefined): string => {
  if (!date || !isValid(date)) {
    return new Date().toISOString();
  }
  return date.toISOString();
};

export const isValidDate = (date: any): date is Date => {
  return date instanceof Date && isValid(date);
};
